import type { interfaces } from "inversify";
import LocalizationService from "services/localizationService";
import { Modules } from "config";
import AdHocReportsConfirmationViewModel from "./adHocReportsConfirmationViewModel";

export default class AdHocReportsProcessedViewModel extends AdHocReportsConfirmationViewModel {
  constructor(public localizationService: LocalizationService) {
    super(localizationService);
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.timeCharges, `adHocReports.processedModal.${code}`, size);
  }

  static Factory({ container }: interfaces.Context) {
    return () => new AdHocReportsProcessedViewModel(container.get(LocalizationService));
  }
}
